function positiveInt(value) {
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : null;
}

function dateValue(row) {
  return row?.appointment_starts_at
    || row?.scheduled_start
    || row?.scheduled_at
    || row?.completed_at
    || null;
}

function earliestDateValue(rows) {
  let best = null;
  let bestTime = null;
  for (const row of rows || []) {
    const value = dateValue(row);
    if (!value) continue;
    const time = new Date(value).getTime();
    if (Number.isNaN(time)) continue;
    if (bestTime == null || time < bestTime) {
      best = value;
      bestTime = time;
    }
  }
  return best;
}

function lowestPhase(rows) {
  const phases = (rows || [])
    .map((row) => positiveInt(row?.phase_number))
    .filter(Boolean);
  if (phases.length === 0) return null;
  return Math.min(...phases);
}

function phaseMeta(plan, phaseNumber) {
  if (!plan || !phaseNumber) return null;
  const meta = plan.phase_meta?.[String(phaseNumber)] ?? plan.phase_meta?.[phaseNumber];
  const offsetDays = positiveInt(meta?.offset_days);
  const afterPhase = positiveInt(meta?.after_phase);
  if (!offsetDays || !afterPhase) return null;
  return { offsetDays, afterPhase };
}

export function resolvePhaseCadence({ plan, visits = [], targetPhase }) {
  const target = positiveInt(targetPhase);
  const meta = phaseMeta(plan, target);
  if (!meta) return null;
  const referenceRows = (visits || []).filter(
    (visit) => positiveInt(visit?.phase_number) === meta.afterPhase,
  );
  const anchorDate = earliestDateValue(referenceRows);
  if (!anchorDate) return null;
  return {
    anchorDate,
    afterPhase: meta.afterPhase,
    offsetDays: meta.offsetDays,
    targetPhase: target,
  };
}

export function resolvePhaseCadenceForVisits({ plan, visits = [], selectedVisits = [] }) {
  return resolvePhaseCadence({
    plan,
    visits,
    targetPhase: lowestPhase(selectedVisits),
  });
}

export function resolvePhaseCadenceForItems({ plan, visits = [], selectedItems = [] }) {
  return resolvePhaseCadence({
    plan,
    visits,
    targetPhase: lowestPhase(selectedItems),
  });
}
